import { useRef, useEffect, useState } from "react";
import whiteLogo from "Assets/logo.png";
import logo from "../../Assets/NewYear/black-logo.png";
import newCustomersText from "../../Assets/NewYear/new-customer-text.svg";
import sales from "../../Assets/NewYear/sales.png";
import campaigns from "../../Assets/NewYear/campaigns.png";
import ai from "../../Assets/NewYear/ai.png";
import branding from "../../Assets/NewYear/branding.png";
import content from "../../Assets/NewYear/content.png";
import talent from "../../Assets/NewYear/talent.png";
import video from "../../Assets/NewYear/video.png";
import section2 from "../../Assets/NewYear/section2.png";
import YouTubeEmbed from "Components/YoutubeEmbed/YouTubeEmbed";
import trySignText from "../../Assets/NewYear/try-sign-text.png";
import campaignsBox from "../../Assets/NewYear/campaigns-box.png";

import adsSec3 from "../../Assets/NewYear/on-demand/ads.png";
import contentSec3 from "../../Assets/NewYear/on-demand/content.png";
import videoSec3 from "../../Assets/NewYear/on-demand/video.png";
import talentSec3 from "../../Assets/NewYear/on-demand/talent.png";
import copySec3 from "../../Assets/NewYear/on-demand/copy.png";
import designSec3 from "../../Assets/NewYear/on-demand/design.png";
import devSec3 from "../../Assets/NewYear/on-demand/dev.png";
import digitalSec3 from "../../Assets/NewYear/on-demand/digital-marketing.png";
import marketingSec3 from "../../Assets/NewYear/on-demand/marketing.png";
import seoSec3 from "../../Assets/NewYear/on-demand/seo.png";
import socialSec3 from "../../Assets/NewYear/on-demand/social.png";
import webSec3 from "../../Assets/NewYear/on-demand/web.png";

import campaignsSec3 from "../../Assets/NewYear/on-demand/campaigns.png";
import salesSec3 from "../../Assets/NewYear/on-demand/sales.png";

import section5 from "../../Assets/NewYear/section5.png";

import section61 from "../../Assets/NewYear/section6.1.png";
import section62 from "../../Assets/NewYear/section6.2.png";
import section63 from "../../Assets/NewYear/section6.3.png";

import section7bg from "../../Assets/NewYear/section7bg.png";
import sideCard from "../../Assets/NewYear/side-card.png";
import useScreen from "../../hooks/useScreen";
import graphicalSales from "../../Assets/NewYear/graphical-sales.png";
import videoSales from "../../Assets/NewYear/video-sales.png";
import explainerVideo from "../../Assets/NewYear/explainer-video.png";
import showReels from "../../Assets/NewYear/show-reels.png";
import shorts from "../../Assets/NewYear/shorts.png";
import landgingPage from "../../Assets/NewYear/landing-page.png";

const NewYearPromoPage = () => {
    const screen = useScreen();
	const campaignsRef = useRef<HTMLDivElement>(null);
    const newCustomersTextRef = useRef<HTMLImageElement>(null);
    const [youtubeVideoId, setYoutubeVideoId] = useState<string | null>(null);
    const calendlyLink = "https://calendly.com/salesbox-meet/salesmrkt";

	const handleYoutubeClick = (videoId: string) => {
		setYoutubeVideoId(videoId);
	};

	useEffect(() => {
		const updatePosition = () => {
			if (campaignsRef.current && newCustomersTextRef.current && screen) {
				const rect = campaignsRef.current.getBoundingClientRect();
				const containerRect = campaignsRef.current.parentElement?.getBoundingClientRect();
				if (containerRect && newCustomersTextRef.current) {
					const top = rect.top - containerRect.top;
					const left = rect.left - containerRect.left - 160; // 160px = 10rem
					newCustomersTextRef.current.style.top = `${top-(screen.width < 750 ? 60: 85)}px`;
					newCustomersTextRef.current.style.left = `${left+(screen.width < 750 ? 80: 45)}px`;
				}
			}
		};

		// Use requestAnimationFrame to ensure DOM is rendered
		requestAnimationFrame(() => {
			setTimeout(updatePosition, 0);
		});

		window.addEventListener("resize", updatePosition);
		return () => window.removeEventListener("resize", updatePosition);
	}, [screen]);
    const services = [
			{
				name: "Sales",
				image: sales,
			},
			{
				name: "Campaigns",
				image: campaigns,
			},
			{ name: "Branding", image: branding },
			{
				name: "Content",
				image: content,
			},
			{ name: "Video", image: video },
			{ name: "Talent", image: talent },
			{ name: "AI", image: ai },
    ];
    
    const sec3Images = [marketingSec3, videoSec3, contentSec3, copySec3, digitalSec3, webSec3, seoSec3, adsSec3, socialSec3, designSec3, talentSec3, devSec3];
    
    const sec6 = [
			{
				img: section61,
				greenText: "Grow Your Revenue with",
				blackText: "Sales & Business Dev",
			},
			{
				img: section62,
				greenText: "Build Your Brand with",
				blackText: "Marketing & Content",
			},
			{
				img: section63,
				greenText: "Scale Your Business with",
				blackText: "Tech & AI",
			},
		];
    
    const multimediaAssets = [
			{
				title: "Graphical Sales Funnel",
				image: graphicalSales,
				borderGradient: "linear-gradient(90deg, #70C242 0%, #B0D238 100%)",
				buttonGradient: "linear-gradient(90deg, #70C242 0%, #B0D238 100%)",
				buttonTextColor: "text-black",
				playButtons: [
					{ videoId: "vbsIlaOhGL4" },
					{ videoId: "F4TscrzLttw" },
					{ videoId: "FJwtDmMtrUY" },
				],
				isBottom: false,
				imageClass: "h-[8rem] w-auto",
			},
			{
				title: "Video Sales Funnel",
				image: videoSales,
				borderGradient: "linear-gradient(90deg, #4263C2 0%, #38A1D2 100%)",
				buttonGradient: "linear-gradient(90deg, #4263C2 0%, #38A1D2 100%)",
				buttonTextColor: "text-white",
				playButtons: [
					{ videoId: "0V-OG1Hz8d0" },
					{ videoId: "PXnXMnHz9NI" },
					{ videoId: "a3iOpVTiK_U" },
				],
				isBottom: false,
				imageClass: "h-[8rem] w-auto",
			},
			{
				title: "Explainer Video",
				image: explainerVideo,
				borderGradient: "linear-gradient(90deg, #7B60DD 0%, #A890FF 100%)",
				buttonGradient: "linear-gradient(90deg, #7B60DD 0%, #A890FF 100%)",
				buttonTextColor: "text-white",
				playButtons: [{ videoId: "oNILWL24F8w" }],
				isBottom: true,
				imageClass: "h-[8rem] w-auto",
			},
			{
				title: "Show Reels",
				image: showReels,
				borderGradient: "linear-gradient(90deg, #0FBFDF 0%, #38A1D2 100%)",
				buttonGradient: "linear-gradient(90deg, #0FBFDF 0%, #38A1D2 100%)",
				buttonTextColor: "text-white",
				playButtons: [
					{ videoId: "7aL_1DUyFLk" },
					{ videoId: "-_uZ1CCTXeg" },
					{ videoId: "d1Eqtgq-0kU" },
				],
				isBottom: false,
				imageClass: "h-[6rem] w-auto",
			},
			{
				title: "Shorts",
				image: shorts,
				borderGradient: "linear-gradient(90deg, #962698 0%, #6038D2 100%)",
				buttonGradient: "linear-gradient(90deg, #962698 0%, #6038D2 100%)",
				buttonTextColor: "text-white",
				playButtons: [{ url: "https://www.youtube.com/shorts/8vOFdQLp-bQ" }],
				isBottom: false,
				imageClass: "h-[8rem] w-auto",
			},
			{
				title: "Landing Page",
				image: landgingPage,
				borderGradient: "linear-gradient(90deg, #DF730F 0%, #871F1F 100%)",
				buttonGradient: "linear-gradient(90deg, #DF730F 0%, #871F1F 100%)",
				buttonTextColor: "text-white",
				playButtons: [
					{
						url: "https://www.figma.com/proto/7hV2Uk7TM35XrPOL55M4UY/CC?page-id=2325%3A2&node-id=2325-7&t=iVnyjJfnCf90hwma-0&scaling=min-zoom&starting-point-node-id=2325%3A7",
					},
					{
						url: "https://www.figma.com/proto/3eQFZ3cTTAR59p9xfqQRLJ/MG-Pictures?page-id=0%3A1&node-id=0-3&viewport=599%2C1197%2C0.25&t=nMTNXLnsBcZF9fdj-1&scaling=scale-down-width",
					},
				],
				isBottom: false,
				imageClass: "h-[8rem] w-auto",
			},
		];

    return (
			<div className="w-full h-auto">
				{youtubeVideoId && (
					<div>
						<YouTubeEmbed
							videoId={youtubeVideoId}
							onClose={() => setYoutubeVideoId(null)}
						/>
					</div>
				)}
				<section className="pb-8 flex flex-col items-center justify-center w-full">
					<div className="flex flex-row items-center justify-between w-full ">
						<div className="text-2xl font-bold bg-black p-4 text-[#84CC16] rounded-br-[25px] w-[160px]">
							Year End Promotion
						</div>
						<img
							src={logo}
							className="w-25 h-6 mx-8"
							alt="year-end-promotion"
						/>
					</div>
					<div className="flex flex-col font-semibold items-center text-center justify-center">
						<div className="text-6xl">Grow Your Business</div>
						<div className="text-5xl">with our Signature Services!</div>
					</div>
					<button onClick={() => window.open(calendlyLink, "_blank")} className="flex flex-col items-center justify-center bg-[#84CC16] rounded-full px-8 py-4 md:px-12 md:py-5 text-center max-w-2xl mx-auto mt-6">
						<div className="relative text-2xl md:text-3xl lg:text-4xl font-bold text-black w-fit">
							Free until Jan 15{" "}
							<sup className="font-semibold text-xl absolute top-0 -right-6">
								TH
							</sup>
						</div>
						<div className="text-xs text-white mt-2">
							*Discount comes with sign up of standard agreement
						</div>
					</button>
					<div className="flex flex-col items-left justify-center w-full">
						<div className="flex flex-row flex-wrap items-center justify-evenly gap-4 w-full pt-[5rem] relative">
							<img
								ref={newCustomersTextRef}
								src={newCustomersText}
								alt="new-customers-text"
								className="absolute w-[8rem] h-[4rem] md:w-[10rem] md:h-[5rem] object-contain z-10 pointer-events-none"
							/>
							{services.map((service) => (
								<div
									key={service.name}
									ref={service.name === "Campaigns" ? campaignsRef : null}
									className="flex flex-col items-center justify-center"
								>
									<img
										src={service.image}
										alt={service.name}
										className="w-20 h-20 object-contain"
									/>
									<div className="font-semibold">{service.name}</div>
								</div>
							))}
						</div>
					</div>
				</section>
				<section className="relative flex flex-col items-center justify-center w-full h-full pt-8 bg-[#F9FFF0]">
					<p className="text-4xl md:text-5xl lg:text-6xl font-semibold max-w-[30rem] md:max-w-[45rem] lg:max-w-[55rem] text-center">
						This Video will Change How You Think About{" "}
						<span className="text-[#84CC16]">Revenue</span>
					</p>
					<div className="relative w-full">
						<img
							src={section2}
							alt="section2"
							className="w-full h-auto object-contain"
						/>
						<div
							onClick={() => handleYoutubeClick("UXHBAW82O_I")}
							className="absolute top-[16%] left-[47%] w-[4.2%] h-[10%] cursor-pointer rounded-[25px]"
						></div>
					</div>
				</section>
				<section className="flex flex-col items-center justify-center w-full h-full p-10">
					<div className="flex flex-col items-center justify-center text-center gap-2">
						<p className="text-3xl md:text-5xl lg:text-6xl font-semibold max-w-[30rem] md:max-w-[45rem] lg:max-w-[55rem] text-center items-start relative">
							Campaigns OnDemand
							<sup className="font-semibold text-xl absolute top-0 -right-7">
								TM
							</sup>
						</p>
						<p className="lg:text-2xl text-lg font-semibold">
							<span className="text-[#84CC16]">$5,000</span> Savings for New
							Clients
						</p>
					</div>
					<div className="relative flex flex-row items-center justify-center w-full gap-3">
						<img
							src={trySignText}
							alt="try-sign-text"
							className="w-[10rem] h-[7rem] md:w-[12rem] md:h-[8rem] lg:w-[14rem] lg:h-[10rem] object-contain"
						/>
						<img
							src={campaignsBox}
							alt="campaigns-box"
							className="w-auto h-[20rem] md:h-[30rem] lg:h-[41rem] object-contain"
						/>
						<p className="lg:text-2xl text-lg font-semibold w-[10rem] md:w-[12rem] md:h-[8rem] lg:w-[14rem] lg:h-[10rem] pt-[10rem]">
							Get 6-8 New Opportunities Every Month
						</p>
					</div>
				</section>
				<section className="flex flex-col items-center justify-center w-full h-full p-10 px-6 bg-[#F6F6F6]">
					<p className="text-3xl md:text-5xl lg:text-6xl font-semibold text-center items-start relative">
						Try Our OnDemand Packages
					</p>
					<p className="lg:text-2xl md:text-xl text-lg font-semibold">
						Get an instant expert team ready to go to work
					</p>
					<div className="flex flex-row items-center justify-center w-full gap-6 mt-8">
						{/* Left side - Grid of 12 images */}
						<div className="grid grid-cols-4">
							{sec3Images.map((image, index) => (
								<img
									key={index}
									src={image}
									alt={`service-${index}`}
									className="w-full h-full object-fill"
								/>
							))}
						</div>
						{/* Right side - Campaigns and Sales */}
						<div className="flex flex-col items-center justify-center mb-5">
							<img
								src={campaignsSec3}
								alt="campaigns-ondemand"
								className="w-full h-[46%] object-contain cursor-pointer"
								onClick={() => {
									window.location.reload();
								}}
							/>
							<p className="lg:text-2xl md:text-xl text-lg w-fit text-center">
								BEST SELLER
							</p>
							<img
								src={salesSec3}
								alt="sales-ondemand"
								className="w-full h-[46%] object-contain"
							/>
						</div>
					</div>
				</section>
				<section
					className="relative w-[100%] bg-cover gap-3 xl:h-[450px] h-[300px] bg-no-repeat flex"
					style={{ backgroundImage: "url('/video-bg-2.jpg')" }}
				>
					<div className="my-auto">
						<div className="max-w-[30rem] xl:max-w-[50rem] mx-auto px-6 py-auto">
							<div className="max-w-xl gap-2 lg:gap-3 flex flex-col justify-left">
								<h1 className="text-3xl lg:text-5xl font-bold text-white lg:leading-[3.5rem]">
									Meet The <br />
									<span className="text-[#84CC16]">Salesmrkt Team</span>
								</h1>
								<p className="text-white text-lg lg:text-xl">
									And launch your service in 5 days
								</p>
								<a
									href={calendlyLink}
									target="_blank"
									rel="noopener noreferrer"
									className="bg-brand-green text-white flex w-fit justify-center items-center text-md md:text-lg lg:text-xl h-10 md:h-12 lg:h-14 rounded-full lg:px-8 px-6 border border-brand-green hover:border-black hover:bg-white hover:text-[#84CC16] transition-all duration-200 ease-in-out whitespace-nowrap mt-5"
								>
									Book a Meeting
								</a>
							</div>
						</div>
					</div>
					<img
						src={section5}
						alt="section5"
						className="absolute right-0 top-[25%] xl:top-[10%] w-auto h-[60%] xl:h-[80%] object-contain"
					/>
				</section>
				<section className="flex flex-row items-start justify-center w-full bg-white py-10">
					{sec6.map((item, index) => (
						<div
							key={index}
							className={`flex-1 flex flex-col items-center justify-start ${
								index < sec6.length - 1 ? "border-r-2 border-gray-300" : ""
							}`}
						>
							<div className="flex flex-col items-center justify-center mb-4 px-4 w-full min-h-[120px] md:min-h-[140px] lg:min-h-[160px] flex-shrink-0">
								<p className="lg:text-4xl text-2xl font-semibold text-[#84CC16] text-center mb-2">
									{item.greenText}
								</p>
								<p className="lg:text-4xl text-2xl font-bold text-black text-center">
									{item.blackText}
								</p>
							</div>
							<div className="w-full flex items-start justify-center px-2 pt-0">
								<img
									src={item.img}
									alt={item.blackText}
									className="w-full h-auto object-contain px-4"
								/>
							</div>
						</div>
					))}
				</section>
				<section className="relative w-full h-auto flex flex-row items-center justify-between px-10 overflow-hidden">
					{/* Background Image */}
					<div className="absolute inset-0 w-full h-full">
						<img
							src={section7bg}
							alt="section7 background"
							className="w-full h-full object-cover"
						/>
					</div>

					{/* Left Side - Text Content */}
					<div className="relative z-10 flex flex-col items-start justify-center gap-6 flex-1 xl:pl-[10rem] pl-0 lg:py-16 md:py-12 py-10">
						<div className="flex flex-col text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-black leading-tight">
							<p>Get Any</p>
							<p>Service Package</p>
						</div>
						<button onClick={() => window.open(calendlyLink, "_blank")} className="bg-[#84CC16] text-white text-2xl font-bold px-8 py-4 rounded-full">
							Free until Jan 15<sup>TH</sup>
						</button>
					</div>

					{/* Right Side - Card Image */}
					<div className="relative z-10 flex items-center justify-center flex-1">
						<img
							src={sideCard}
							alt="service package card"
							className="w-auto h-[30rem] max-w-full object-contain"
						/>
					</div>
				</section>
				<section className="w-full bg-white py-12 px-8">
					{/* Title */}
					<h2 className="text-5xl font-bold text-center mb-10 text-black">
						Multimedia Assets
					</h2>

					{/* Grid of 6 items - 3 columns, 2 rows */}
					<div className="grid grid-cols-1 lg:grid-cols-2 gap-4 max-w-7xl mx-auto items-stretch auto-rows-fr">
						{multimediaAssets.map((asset, index) => (
							<div
								key={index}
								className="rounded-2xl p-[2px] h-full self-stretch"
								style={{ background: asset.borderGradient }}
							>
								<div className="bg-white rounded-2xl p-6 relative overflow-hidden flex items-center h-full">
									{/* Title */}
									<h3 className="text-2xl font-bold text-black w-[25%]">
										{asset.title}
									</h3>

									{/* Content Container */}
									<div className="relative flex flex-row items-center w-[67%] h-full">
										{/* Play Buttons - Left Side */}
										<div className="flex flex-col gap-2 flex-1 relative z-10 pr-4 justify-center">
											{asset.playButtons.map((button, btnIndex) => (
												<button
													key={btnIndex}
													onClick={() => {
														if ("videoId" in button) {
															handleYoutubeClick(button.videoId);
														} else {
															window.open(button.url, "_blank");
														}
													}}
													className={`${asset.buttonTextColor} ml-[6rem] rounded-full px-4 py-2 flex items-center gap-2 hover:opacity-90 transition-opacity w-fit`}
													style={{ background: asset.buttonGradient }}
												>
													<svg
														className="w-3 h-3"
														fill="currentColor"
														viewBox="0 0 20 20"
													>
														<path d="M6.3 2.841A1.5 1.5 0 004 4.11V15.89a1.5 1.5 0 002.3 1.269l9.344-5.89a1.5 1.5 0 000-2.538L6.3 2.84z" />
													</svg>
													<span className="font-semibold text-xs">
														Play Sample {btnIndex + 1}
													</span>
												</button>
											))}
										</div>

										{/* Image - Far Right, Absolute Positioned, Can Extend to Bottom */}
										<div
											className={`absolute -right-[21%] ${
												asset.isBottom ? "-bottom-10" : "top-0"
											}`}
										>
											<img
												src={asset.image}
												alt={asset.title}
												className={`${asset.imageClass} `}
											/>
										</div>
									</div>
								</div>
							</div>
						))}
					</div>
				</section>

				<div className="bg-brand-charcoal px-2 lg:px-5 w-full h-auto py-4 text-white text-center items-center justify-center">
					<div className="flex flex-col md:flex-row gap-3 text-center items-center justify-center ">
						<img src={whiteLogo} alt="Salesmrkt Logo" className="w-auto h-5" />
						<p>© {new Date().getFullYear()}, Salesmrkt. All Rights Reserved.</p>
					</div>
				</div>
			</div>
		);
}

export default NewYearPromoPage;